define([
    "jquery",
    "underscore",
    "marionette",
    "forms/profile/phone_verification_form",
    "forms/profile/phone_verification_simple_form",
    "behaviors/form_errors_behavior",
    "views/profile/upload_documents_view",
    "forms/profile/poa_form",
    "forms/profile/ple_form",
    "forms/profile/selfie_form",
    "behaviors/countdown_behavior",
    "behaviors/phone_country_behavior",
    "js-sha256/src/sha256",
    "select2"
], function ($, _, Marionette, PhoneVerificationForm, PhoneVerificationSimpleForm, FormErrorsBehavior, UploadDocumentsView, PoaForm, PleForm, SelfieForm, CountdownBehavior, PhoneCountryBehavior, sha256) {
    return UploadDocumentsView.extend({
        ui: {
            'pleFile': '#ple_file',
            'pleName': '#ple_name',
            'ple': '#ple',
            'pleSubmit': '#submit_ple',
            'smsForm': '#sms_form',
            'pleForm': '#ple_form',
            'poaFile': '#poa_file',
            'poaName': '#poa_name',
            'poa': '#poa',
            'poaSubmit': '#submit_poa',
            'poaForm': '#poa_form',
            'selfieForm': '#selfie_form',
            'selfieFile': '#selfie_file',
            'selfieSubmit': '#submit_selfie',
            'selfieFileLabelName': '#selfie_file_name',    
            'selfieFileLabelDownload': '#selfie_file_download',
            'selfieFileLabelSuccess': '#selfie_file_label_success',  
            'selfieExtensionError': '#selfie_extension_error',
            'selfie': '#selfie',
            'selfieName': '#selfie_name',
            'pleFileLabel': '#ple_file_label_name',
            'pleFileLabelDownload': '#ple_file_label_download',
            'pleFileLabelSuccess': '#ple_file_label_success',
            'poaFileLabel': '#poa_file_label_name',
            'poaFileLabelDownload': '#poa_file_label_download',
            'poaFileLabelSuccess': '#poa_file_label_success',
            'disabledSubmits': 'button:submit:disabled',

            // Phone validation ==
            'mobileCode': '#mobile_country',
            'mobileRest': '#mobile_rest',
            'phoneNumber': '#phone_number',

            'sendPhoneValidation': '#send_phone_validation',
            'updatePhoneNumber': '#send_phone_validation_validate',
            'checkPhoneValidation': '#check_phone_validation',
            'phoneSendForm': '#phone_send_form',
            'phoneValidationForm': '#phone_validation_form',
            'phoneValidationCode': '#phone_validation',
            'phoneValidationId': '#phone_validation_id',
            'phoneValidationSuccessIcon': '#phone_validation_success',
            'phoneValidationGroup': '#phone_validation_group',
            'phoneValidationPassed': '#phone_validation_passed',

            'phoneValidationCodeBox': '#phone_validation_code_box',
            // Phone validation ==

            // resend verification
            'countdownTimer': '#countdown-timer',
            'afterCountdown': '.after-countdown',
            'resendVerificationPhone': '#resend-phone-verification',
            'createPopupBtn': '.create-popup',

            'pleExtensionError': '#ple_extension_error',
            'poaExtensionError': '#poa_extension_error',
        },

        events: {
            'click @ui.pleSubmit': function (e) {
                if (e) e.preventDefault();

                if(this.ui.pleSubmit.hasClass('active'))
                    this.submit('ple');
            },
            'click @ui.poaSubmit': function (e) {
                if (e) e.preventDefault();

                if(this.ui.poaSubmit.hasClass('active')) 
                {
                    this.triggerMethod('hide:errors')
                    this.submit('poa');
                }
            },
            'click @ui.selfieSubmit': function (e) {
                if (e) e.preventDefault();

                if(this.ui.selfieSubmit.hasClass('active'))
                    this.submit('selfie');
            },
            'change @ui.pleName': function (e) {
                if (e) e.preventDefault();

                if (this.ui.pleName.val().length > 0) {
                    this.ui.pleFileLabel.html(this.ui.pleName.val());
                    this.ui.pleFileLabelSuccess.show();
                    this.ui.pleFileLabelDownload.hide();
                } else {
                    this.ui.pleFileLabel.html("");
                    this.ui.pleFileLabelSuccess.hide();
                    this.ui.pleFileLabelDownload.show();
                }

            },
            'change @ui.poaName': function (e) {
                if (e) e.preventDefault();

                this.ui.poaFileLabel.html(this.ui.poaName.val());

                if (this.ui.poaName.val().length > 0) {
                    this.ui.poaFileLabel.html(this.ui.poaName.val());
                    this.ui.poaFileLabelSuccess.show();
                    this.ui.poaFileLabelDownload.hide();
                } else {
                    this.ui.poaFileLabel.html("");
                    this.ui.poaFileLabelSuccess.hide();
                    this.ui.poaFileLabelDownload.show();
                }
            },
            'input @ui.mobileRest': function (e) {
                this.checkInput(this.ui.sendPhoneValidation, e.target.value);
                this.checkInput(this.ui.updatePhoneNumber, e.target.value);
            },
            'keyup @ui.phoneValidationCode': function (e) {
                this.checkInput(this.ui.checkPhoneValidation, e.target.value);
            },
            'change @ui.phoneValidationCode': function (e) {
                this.checkInput(this.ui.checkPhoneValidation, e.target.value);
            },
            'change @ui.pleFile': function (e) {
                this.ui.pleExtensionError.attr('hidden', 'hidden');

                if(this.hasCorrectExtension($('#ple_file'))) 
                {
                    this.ui.pleSubmit.addClass('active');
                    this.ui.pleForm.addClass('active');
                } else 
                {
                    this.ui.pleExtensionError.removeAttr('hidden');
                    this.ui.pleSubmit.removeClass('active');
                    this.ui.pleForm.removeClass('active');
                }
            },
            'change @ui.poaFile': function (e) {
                this.ui.poaExtensionError.attr('hidden', 'hidden');

                if(this.hasCorrectExtension($('#poa_file'))) 
                {
                    this.ui.poaSubmit.addClass('active');
                    this.ui.poaForm.addClass('active');
                } else 
                {
                    this.ui.poaExtensionError.removeAttr('hidden');
                    this.ui.poaSubmit.removeClass('active');
                    this.ui.poaForm.removeClass('active');
                }
            },
            'change @ui.selfieFile': function (e) {
                this.ui.selfieExtensionError.attr('hidden', 'hidden');

                if(this.hasCorrectExtension(this.ui.selfieFile)) {
                    this.ui.selfieSubmit.addClass('active');
                    this.ui.selfieForm.addClass('active');
                    
                    const filename = this.ui.selfieFile[0].files[0].name;
                    this.ui.selfieFileLabelName.html(filename);
                    this.ui.selfieFileLabelSuccess.show();
                    this.ui.selfieFileLabelDownload.hide();
                } else {
                    this.ui.selfieExtensionError.removeAttr('hidden');
                    this.ui.selfieSubmit.removeClass('active');
                    this.ui.selfieForm.removeClass('active');
                    
                    this.ui.selfieFileLabelName.html('');
                    this.ui.selfieFileLabelSuccess.hide();
                    this.ui.selfieFileLabelDownload.show();
                }
            },
            'click @ui.selfieSubmit': function (e) {
                if (e) e.preventDefault();

                if(this.ui.selfieSubmit.hasClass('active')) {
                    this.triggerMethod('hide:errors');
                    this.submit('selfie');
                }
            },
            'keypress @ui.mobileCode': 'changePhoneNumber',
            'change @ui.mobileCode': 'changePhoneNumber',
            'click @ui.sendPhoneValidation': 'sendPhoneValidation',
            'click @ui.updatePhoneNumber': 'checkSimplePhoneValidation',
            'click @ui.checkPhoneValidation': 'checkPhoneValidation',
            'click @ui.resendVerificationPhone': 'resendPhoneValidation',
            'click @ui.createPopupBtn': 'preventCollapse'
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            },
            countdown: {
                behaviorClass: CountdownBehavior,
            },
            phoneCountry: {
                behaviorClass: PhoneCountryBehavior
            }
        },

        initialize: function () {
            this.bindUIElements();
            this.delegateEvents();

            UploadDocumentsView.prototype.initialize.apply(this);

            this.pleForm = new PleForm();
            this.poaForm = new PoaForm();
            this.selfieForm = new SelfieForm();

            this.initLegalFileUpload(this.ui.pleFile, 'ple');
            this.initLegalFileUpload(this.ui.poaFile, 'poa');
            if (window.selfie_required) {
                this.initLegalFileUpload(this.ui.selfieFile, 'selfie');
            }

            this.checkInput(this.ui.sendPhoneValidation, this.ui.mobileRest.val());
            this.checkInput(this.ui.updatePhoneNumber, this.ui.mobileRest.val());
            this.changePhoneNumber();

            this.ui.disabledSubmits.parent().tooltip();

            this.triggerMethod('initPhoneCountryInput', '.phone_country_select2');
        },

        hasCorrectExtension: function(fileInput) {
            const fileList = fileInput[0].files

            if(fileList.length <= 0)
                return false;

            const filename = fileList[0].name;
            const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i

            return allowedExtensions.exec(filename) != null
        },

        checkInput: function (ui, value) {
            if (value.length > 0) {
                ui.addClass('active');
                ui.removeAttr('disabled');
            } else {
                ui.removeClass('active');
                ui.attr('disabled', 'disabled');
            }
        },

        changePhoneNumber: function () {
            let sms_countries = window.sms_countries ? window.sms_countries : [];
            if (!sms_countries.includes(this.ui.mobileCode.val())) {
                this.ui.sendPhoneValidation.hide();
                this.ui.updatePhoneNumber.show();
                this.ui.phoneValidationCodeBox.hide();
            } else {
                this.ui.sendPhoneValidation.show();
                this.ui.updatePhoneNumber.hide();
                this.ui.phoneValidationCodeBox.show();
            }
        },

        getCodeChallenge: function (payload, timestamp) {
            // Handle the security token for the SMS request
            let secretKey = "smtPpkFPs9gwArYsG2NC";

            // Encrypt the secret and timestamp to generate code_challenge
            let repeat = timestamp % 10 + 1;
            let append = String(timestamp).repeat(repeat);

            return sha256(secretKey + append + JSON.stringify(payload));
        },

        // Phone validation
        sendPhoneValidation: function (e) {
            if (e) e.preventDefault();
            var that = this;
            this.isCountdownEnd = false;
            // this.ui.afterCountdown.hide();

            if (this.ui.mobileRest.val() === '') {
                return;
            }

            let payload = {
                'phone_number': this.ui.mobileCode.val() + this.ui.mobileRest.val(),
            }
            let timestamp = Date.now();
            let codeChallenge = this.getCodeChallenge(payload, timestamp);

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            $.ajax('/rest_profile/verify_phone_number', {
                method: "POST",
                headers: {
                    "Authorization": codeChallenge
                },
                data: {
                    'phone_number': this.ui.mobileCode.val() + this.ui.mobileRest.val(),
                    'timestamp': timestamp
                },
                success: function (data) {
                    that.triggerMethod('hide:errors');
                    that.ui.phoneValidationId.val(data.secureVerificationCd);
                    that.ui.phoneNumber.val(data.phoneNumber);
                    that.ui.phoneValidationForm.show();
                    that.ui.phoneSendForm.hide();
                    // that.ui.sendPhoneValidationBtn.hide();
                    that.ui.mobileCode.select2("enable", false)
                    that.ui.mobileCode.attr('readonly', 'readonly');
                    that.ui.mobileRest.attr('readonly', 'readonly');

                    HoldOn.close();

                    that.ui.phoneValidationCodeBox.toggleClass('disabled');
                    that.ui.sendPhoneValidation.attr('disabled', 'disabled');
                    that.ui.sendPhoneValidation.removeClass('active');
                    that.ui.phoneValidationCode.removeAttr('disabled');
                    that.ui.checkPhoneValidation.removeAttr('disabled');


                    // that.ui.afterCountdown.parent().show();
                    that.triggerMethod('startCountdown', 300, function () {
                        that.isCountdownEnd = true;
                        that.ui.sendPhoneValidation.hide();
                        that.ui.resendVerificationPhone.show();
                        that.ui.phoneSendForm.show();
                        that.ui.mobileRest.attr('readonly', false);
                        that.ui.afterCountdown.show();
                    });
                },
                error: function (xhr, textStatus, errorThrown) {
                    const error = xhr.responseJSON;
                    if (error.error_code === 'client-0000') {
                        that.triggerMethod('show:errors', error.error_message);
                    } else {
                        that.triggerMethod('show:errors', {'mobile_rest': error.error_message});
                    }

                    HoldOn.close();
                }
            })
        },

        checkPhoneValidation: function (e) {
            if (e) e.preventDefault();

            this.triggerMethod('hide:errors');

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            const formData = Backbone.Syphon.serialize(this.$('#sms_form'));
            const form = new PhoneVerificationForm();

            form.set(formData);
            const errors = form.validate();

            const that = this;
            if (_.size(errors) < 1) {
                form.validateWithServer({
                    type: 'POST',
                    success: function (model, res) {
                        that.verifyCheckPhoneNumber()
                    },
                    error: function (model, error) {
                        that.triggerMethod('show:errors', error.responseJSON);
                        HoldOn.close();
                    }
                });
            } else {
                this.triggerMethod('show:errors', errors);
                HoldOn.close();
            }
        },

        checkSimplePhoneValidation: function (e) {
            if (e) e.preventDefault();

            this.triggerMethod('hide:errors');

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            const formData = Backbone.Syphon.serialize(this.$('#sms_form'));
            const form = new PhoneVerificationSimpleForm();

            form.set(formData);
            const errors = form.validate();

            const that = this;
            if (_.size(errors) < 1) {
                form.validateWithServer({
                    type: 'POST',
                    success: function (model, res) {
                        that.updatePhoneNumber();
                    },
                    error: function (model, error) {
                        that.triggerMethod('show:errors', error.responseJSON);
                        HoldOn.close();
                    }
                });
            } else {
                this.triggerMethod('show:errors', errors);
                HoldOn.close();
            }
        },

        verifyCheckPhoneNumber: function (e) {
            const that = this;

            $.ajax('/rest_profile/verify_check_phone_number', {
                method: "POST",
                data: {
                    'mobile_country': this.ui.mobileCode.val(),
                    'mobile_rest': this.ui.mobileRest.val(),
                    'request_id': this.ui.phoneValidationId.val(),
                    'phone_number': this.ui.phoneNumber.val(),
                    'code': this.ui.phoneValidationCode.val()
                },
                success: function (data) {
                    that.triggerMethod('hide:errors');
                    window.location = window.location.href.replace(/#.*$/, "");
                },
                error: function (xhr, textStatus, errorThrown) {
                    const error = xhr.responseJSON;
                    if (error.error_code === 'client-0000') {
                        that.triggerMethod('show:errors', error.error_message);
                    } else {
                        that.triggerMethod('show:errors', {'phone_validation': error.error_message});
                    }

                    HoldOn.close();
                }
            })
        },

        updatePhoneNumber: function (e) {
            const that = this;

            $.ajax('/rest_profile/update_phone_number', {
                method: "POST",
                data: {
                    'mobile_country': this.ui.mobileCode.val(),
                    'mobile_rest': this.ui.mobileRest.val(),
                },
                success: function (data) {
                    that.triggerMethod('hide:errors');
                    window.location = window.location.href.replace(/#.*$/, "");
                },
                error: function (xhr, textStatus, errorThrown) {
                    const error = xhr.responseJSON;
                    if (error.error_code === 'client-0000') {
                        that.triggerMethod('show:errors', error.error_message);
                    } else {
                        that.triggerMethod('show:errors', {'mobile_rest': error.error_message});
                    }

                    HoldOn.close();
                }
            })
        },

        // resend verification
        resendPhoneValidation: function (e) {
            if (e) e.preventDefault();
            if (this.isCountdownEnd)
                this.sendPhoneValidation(e);
            else {
                // does nothing
            }
        },

        preventCollapse: function (e) {
            e.stopPropagation();
        }
    });
});
